// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/pii.proto (package squareup, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file squareup/common/pii.proto.
 */
export const file_squareup_common_pii: GenFile = /*@__PURE__*/
  fileDesc("ChlzcXVhcmV1cC9jb21tb24vcGlpLnByb3RvEghzcXVhcmV1cCovChVOb3JtYWxpemF0aW9uU3RyYXRlZ3kSCwoHREVGQVVMVBABEgkKBUVNQUlMEAIqcQoURGF0YVNlbnNpdGl2aXR5TGV2ZWwSCAoETk9ORRABEg0KCUJBU0lDX1BJSRACEgcKA1BDSRADEgoKBlNFQ1JFVBAEEhgKFEJVU0lORVNTX0lORk9STUFUSU9OEAUSBwoDTlBJEAYSCAoETU5QSRAHOjsKCHJlZGFjdGVkEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxi4rQEgASgIUghyZWRhY3RlZDpBCgt0b2tlbml6YWJsZRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYua0BIAEoCFILdG9rZW5pemFibGU6ZgoNbm9ybWFsaXphdGlvbhIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYuq0BIAEoDjIfLnNxdWFyZXVwLk5vcm1hbGl6YXRpb25TdHJhdGVneVINbm9ybWFsaXphdGlvbjp1ChZkYXRhX3NlbnNpdGl2aXR5X2xldmVsEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxi+rQEgASgOMh4uc3F1YXJldXAuRGF0YVNlbnNpdGl2aXR5TGV2ZWxSFGRhdGFTZW5zaXRpdml0eUxldmVsQiAKHmNvbS5zcXVhcmV1cC5wcm90b3MuY29tbW9uLnBpaQ", [file_google_protobuf_descriptor]);

/**
 * *
 * An enum for normalization strategies.  The values here correspond to those defined in
 * {@link com.squareup.crypto.tokenization.NormalizationStrategy}.
 *
 * @generated from enum squareup.NormalizationStrategy
 */
export enum NormalizationStrategy {
  /**
   * @generated from enum value: DEFAULT = 1;
   */
  DEFAULT = 1,

  /**
   * @generated from enum value: EMAIL = 2;
   */
  EMAIL = 2,
}

/**
 * Describes the enum squareup.NormalizationStrategy.
 */
export const NormalizationStrategySchema: GenEnum<NormalizationStrategy> = /*@__PURE__*/
  enumDesc(file_squareup_common_pii, 0);

/**
 * *
 * Used to indicate how sensitive data is in a field. The values here correspond to the PII levels
 * defined in http://go/piisemantictypes.
 *
 * The API Log inspector reads this enum and filters values that are not NONE or BASIC_PII. If the
 * field is absent then we assume the value is NONE. For more detail, read the proposal doc:
 * https://docs.google.com/document/d/1pMLUuYI-SxGnB85SDffBr95kC3UI4S_5xdRDsZgjkIA/edit#
 *
 * @generated from enum squareup.DataSensitivityLevel
 */
export enum DataSensitivityLevel {
  /**
   * Contains no sensitive data
   *
   * @generated from enum value: NONE = 1;
   */
  NONE = 1,

  /**
   * Basic PII information such as name, email, etc.
   *
   * @generated from enum value: BASIC_PII = 2;
   */
  BASIC_PII = 2,

  /**
   * Payment Card Industry (PCI) Information
   *
   * @generated from enum value: PCI = 3;
   */
  PCI = 3,

  /**
   * Secrets that should be considered highly confidential (password, access token, etc.)
   *
   * @generated from enum value: SECRET = 4;
   */
  SECRET = 4,

  /**
   * Business information
   *
   * @generated from enum value: BUSINESS_INFORMATION = 5;
   */
  BUSINESS_INFORMATION = 5,

  /**
   * Non-Public Information
   *
   * @generated from enum value: NPI = 6;
   */
  NPI = 6,

  /**
   * Material Non-Public Information
   *
   * @generated from enum value: MNPI = 7;
   */
  MNPI = 7,
}

/**
 * Describes the enum squareup.DataSensitivityLevel.
 */
export const DataSensitivityLevelSchema: GenEnum<DataSensitivityLevel> = /*@__PURE__*/
  enumDesc(file_squareup_common_pii, 1);

/**
 * *
 * Fields marked with redacted are not to be logged, generally for PCI or PII.
 * The Java protobuf library automatically redacts these fields when outputting proto
 * fields through TextFormat or AbstractMessage.toString.
 *
 * @generated from extension: optional bool redacted = 22200;
 */
export const redacted: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_squareup_common_pii, 0);

/**
 * *
 * Fields marked as tokenizable, can be tokenized in lieu of being redacted.  An additional
 * normalization strategy can be added to be applied in conjunction with tokenization.
 *
 * @generated from extension: optional bool tokenizable = 22201;
 */
export const tokenizable: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_squareup_common_pii, 1);

/**
 * *
 * Fields marked with a normalization strategy, should have the requested normalization applied
 * prior to other transformations (e.g. prior to tokenization).
 *
 * @generated from extension: optional squareup.NormalizationStrategy normalization = 22202;
 */
export const normalization: GenExtension<FieldOptions, NormalizationStrategy> = /*@__PURE__*/
  extDesc(file_squareup_common_pii, 2);

/**
 * *
 * Fields marked with a data sensitivity level should be used in conjection with `redacted`.
 * The annotation gives more granulariyy into what kind of data is in the field.
 *
 * @generated from extension: optional squareup.DataSensitivityLevel data_sensitivity_level = 22206;
 */
export const data_sensitivity_level: GenExtension<FieldOptions, DataSensitivityLevel> = /*@__PURE__*/
  extDesc(file_squareup_common_pii, 3);

